import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { WinsGallery } from "../components/WinsGallery";

export default function Wins() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen px-6 lg:px-10 py-10 max-w-7xl mx-auto">
      <div className="flex items-center justify-between gap-4">
        <Link to={user?.is_premium ? "/" : "/premium"} className="inline-flex items-center gap-2 text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="wins-back-link">
          <ArrowLeft size={14} strokeWidth={1.5} /> {user?.is_premium ? "Tutte le partite" : "GOAL.AI Premium"}
        </Link>
        {user?.role === "admin" && (
          <Link to="/admin/vincite" data-testid="wins-admin-link" className="text-xs font-bold text-[#FFCC00] hover:text-white">Gestisci vincite</Link>
        )}
      </div>
      <h1 className="heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mt-8">Le nostre vincite</h1>
      <p className="text-sm text-[#A1A1AA] mt-2 max-w-xl">Giocate reali fatte con i pronostici di GOAL.AI e tutte le schedine dell&apos;app risultate vincenti.</p>
      {!user?.is_premium && (
        <Link to={user ? "/premium" : "/register?next=/premium"} data-testid="wins-cta"
          className="mt-6 inline-block bg-[#39FF14] text-black font-black uppercase tracking-wider text-xs px-5 py-3 hover:bg-white transition-colors">
          Sblocca tutte le schedine
        </Link>
      )}
      <div className="mt-10"><WinsGallery /></div>
      <p className="text-[11px] text-[#71717A] mt-10">Le vincite passate non garantiscono quelle future. Il gioco è vietato ai minori e può causare dipendenza.</p>
    </div>
  );
}
